export const Footer = () => (
  <footer data-testid="footer-section" className="bg-[#0E0524] text-bone/60 py-16">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 pb-12 border-b border-bone/10">
        <div>
          <p className="font-display text-3xl font-semibold text-bone tracking-tight">Madhura Gokhale</p>
          <img
            src="https://i.wlycdn.com/wealthy-home-page/wealthy-new-purple-logo.svg"
            alt="Wealthy"
            className="h-9 w-auto mt-3 brightness-0 invert"
          />
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-brand-light mt-2">
            Wealth Partner × Wealthy · AMFI ARN-184789
          </p>
          <a
            data-testid="footer-email-link"
            href="mailto:wealthymadhura@gmail.com"
            className="inline-block mt-3 text-sm text-bone/70 hover:text-brand-light transition-colors duration-300"
          >
            wealthymadhura@gmail.com
          </a>
        </div>
        <p className="max-w-md text-xs leading-relaxed">
          Mutual fund investments are subject to market risks. Read all scheme
          related documents carefully before investing. Past performance is not
          indicative of future returns.
        </p>
      </div>

      <p className="pt-12 text-[11px] text-bone/35">
        © {new Date().getFullYear()} Madhura Gokhale — Wealth Partner. All rights reserved.
      </p>
    </div>
  </footer>
);
